import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { logger } from "../lib/logger";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("omr_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem("omr_cart", JSON.stringify(items)); } catch (e) { logger.warn("cart not saved", e); }
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id);
      const maxStock = product.stock ?? 99;
      if (existing) {
        const newQty = Math.min(existing.qty + qty, maxStock);
        return prev.map((i) => (i.product_id === product.id ? { ...i, qty: newQty } : i));
      }
      return [
        ...prev,
        {
          product_id: product.id,
          slug: product.slug,
          name_en: product.name_en,
          name_ar: product.name_ar,
          price: product.price,
          size: product.size,
          image: product.images?.[0] || "",
          stock: maxStock,
          qty: Math.min(qty, maxStock),
        },
      ];
    });
  };

  const updateQty = (product_id, qty) => {
    setItems((prev) =>
      prev.map((i) => (i.product_id === product_id ? { ...i, qty: Math.max(1, Math.min(qty, i.stock)) } : i))
    );
  };

  const removeItem = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clearCart = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clearCart, count, subtotal, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
